import { LoaderCircle } from "lucide-react";
import { commonCopy } from "@client/locales/id/common";

export function PageLoader() {
  return (
    <div className="flex min-h-[60dvh] items-center justify-center" role="status">
      <LoaderCircle className="size-6 animate-spin text-foreground-muted" aria-hidden="true" />
      <span className="sr-only">{commonCopy.loading}</span>
    </div>
  );
}
